import React, { useState } from "react";
import { Button, Icon, Confirm, Popup, Label } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { Competence } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CompetenceForm } from "../CompetenceForm";
import "./CompetenceItem.scss";

const competenceController = new Competence();

export function CompetenceItem(props) {
  const { competence, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateCompetence = () => {
    setTitleModal(`Actualizar competencia: ${competence.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar la competencia "${competence.name}"?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await competenceController.deleteCompetence(accessToken, competence.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const onToggleStatus = async () => {
    try {
      await competenceController.toggleCompetenceStatus(
        accessToken,
        competence.id,
      );
      onReload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="competence-item">
        <div className="competence-item__info">
          <div className="competence-item__info-header">
            <Label color="blue" size="small">
              {competence.code}
            </Label>
            <span className="competence-item__info-name">
              {competence.name}
            </span>
          </div>
          {competence.description && (
            <span className="competence-item__info-description">
              {competence.description}
            </span>
          )}
          <span className="competence-item__info-order">
            <b>Orden:</b> {competence.order}
          </span>
        </div>
        <div className="competence-item__actions">
          <Popup
            content="Editar competencia"
            trigger={
              <Button icon primary onClick={openUpdateCompetence}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar competencia"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal
        show={showModal}
        size="small"
        close={onOpenCloseModal}
        title={titleModal}
      >
        <CompetenceForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          competence={competence}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
